import { Tabs } from 'antd';
import { Column, Row } from 'farmhub-ui-core';
import styled, { css } from 'styled-components';

export const ModalStyles = css`
  .ant-modal-body {
    padding: 6px !important;
  }
`;

export const CTabs = styled(Tabs)`
  width: 100%;
  overflow: inherit;

  > .ant-tabs-nav {
    position: sticky;
    left: 0;
    z-index: 99;
    background: #fff;

    margin: 0px;

    .ant-tabs-nav-wrap {
      width: 100%;

      .ant-tabs-nav-list {
        width: 100%;

        .ant-tabs-tab {
          padding: 0px 32px 16px !important;
          justify-content: center;
          &:not(:first-child) {
            border-left: none;
          }

          .anticon {
            margin-right: 0px;
          }
        }
      }
    }
  }
  }
`;

export const TabHeaderContentWrapper = styled(Column)<{
  isActive: boolean;
  svgColor?: string;
  svgActiveColor?: string;
  iconWidth?: number;
  iconHeight?: number;
}>`
  svg {
    width: ${p => (p.iconWidth != undefined ? `${p.iconWidth}px` : '18px')};
    height: ${p => (p.iconHeight != undefined ? `${p.iconHeight}px` : '18px')};
    color: ${p =>
      p.isActive
        ? p.svgActiveColor || p.theme.colors.primary.main
        : p.svgColor || p.theme.colors.text.secondary};
  }
`;

export const DesktopWrapper = styled.div`
  width: 100%;
  height: fit-content;
  padding: 12px 18px;
`;

export const DesktopContentWrapper = styled(Column)`
  border: 1px solid #d9d9d9;
  border-radius: 6px;
`;

export const DesktopQRCodeWrapper = styled(Row)`
  padding: 0px;
  width: fit-content;
  height: fit-content;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  .face-logo {
    width: 58px;
    height: 58px;
    background: #ffffff;
    border-radius: 50%;
    padding: 6px;

    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }

    position: absolute;
    // top: 50% !important;
    // left: 50% !important;
    // transform: translate(-50%, -50%) !important;
    z-index: 10;
  }
`;

export const DesktopSupplierLogo = styled.img`
  width: 58px;
  height: 58px;
  object-fit: contain;
  border-radius: 50%;
`;

export const DesktopLinkWrapper = styled.div`
  position: relative;
  border-radius: 6px;
  border: none;

  height: fit-content;
  width: 100%;
  padding: 8px;

  &::before {
    content: ' ';
    width: 100%;
    height: 100%;
    border-radius: 6px;
    background: ${props => props.theme.colors.primary.main};

    opacity: 0.1;
    pointer-events: auto;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
